export enum Page {
    Deviation = 0,
    MissingPart = 1,
    Suppliers = 3
}